import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
    TrainingPlanningAgency,
    TrainingPlanningAgencyService,
} from '../../_services';

@Component({
    selector: 'jhi-trainings',
    templateUrl: 'agency.component.html',
    styleUrls: ['agency.component.scss'],
    providers: [TranslatePipe],
})
export class TrainingPlanningAgencyComponent implements OnInit {
    account: any;
    error: string;
    success: string;
    agencies: TrainingPlanningAgency[];

    constructor(
        private trainingPlanningAgencyService: TrainingPlanningAgencyService
    ) {}

    ngOnInit() {
        this.trainingPlanningAgencyService
            .findAll()
            .subscribe((agencies) => (this.agencies = agencies));
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/training-planning-agency/agency.component.ts